import { Box, FlexView, Image, TextPreset } from '@facile-it/full-metal-ui/components'
import { NextPage } from 'next'
import Head from 'next/head'
import * as React from 'react'
import { Container, HeroCaption, HeroContainer, HeroContent, HeroTitle, Icon } from '../components'
import { Documents } from '../components/Documents'
import contactsImg from '../components/branding/images/Contacts.svg'
import { AppLink } from '../components/routing/AppLink'
import * as styles from '../styles/Pages.css'

const Contatti: NextPage = () => (
    <>
        <Head>
            <title>Contatti | Saturno assicurazioni</title>
        </Head>
        <HeroContainer hasBackground variant="big-one">
            <Box className={styles.heroImageWrapper}>
                <Image src={contactsImg.src} alt="Contatti" className={[styles.heroImage, styles.heroImageContact]} />
            </Box>
            <HeroContent>
                <HeroTitle>Contatti</HeroTitle>
                <HeroCaption>
                    Ti aiutiamo, <strong>ti ascoltiamo!</strong>
                </HeroCaption>
                <FlexView.Container
                    alignItems="center"
                    className={styles.phoneInfo}
                    backgroundColor="white"
                    justifyContent={{ mobile: 'center', tablet: 'flexStart' }}
                >
                    <FlexView.Item>
                        <Icon variant="phone" className={styles.phoneIcon} alt="phone" />
                    </FlexView.Item>
                    <FlexView.Item>
                        <TextPreset preset="paragraph-m" fontWeight="normal" paddingLeft={{ mobile: 'm', tablet: 'l' }}>
                            Non sei ancora un Cliente Saturno Assicurazioni?
                        </TextPreset>
                        <TextPreset
                            preset="title-xl"
                            fontWeight="bold"
                            paddingLeft={{ mobile: 'm', tablet: 'l' }}
                            paddingBottom="xxs"
                        >
                            <AppLink href="tel:+39025555111">02 555 51 11</AppLink> *
                        </TextPreset>
                        <TextPreset
                            preset="paragraph-m"
                            paddingTop="m"
                            paddingLeft={{ mobile: 'm', tablet: 'l' }}
                            fontWeight="normal"
                        >
                            Sei già un Cliente Saturno Assicurazioni?
                        </TextPreset>
                        <TextPreset
                            preset="title-xl"
                            fontWeight="bold"
                            paddingLeft={{ mobile: 'm', tablet: 'l' }}
                            paddingBottom="xxs"
                        >
                            <AppLink href="tel:+3902465488700">02 465 488 700</AppLink>
                        </TextPreset>
                        <TextPreset preset="paragraph-m" paddingLeft={{ mobile: 'm', tablet: 'l' }} fontWeight="normal">
                            dal lunedì al venerdì: 09:00 / 13:00 - 14:00 / 18:00 (festivi esclusi)
                        </TextPreset>
                        {/* 
                            
                            !! THIS PIECE WILL BE ACTIVATED LATER !!
                            
                            <Hidden below="mobileXl">
                                <Text
                                    paddingLeft={{ mobile: 'stdplus', tablet: 'large' }}
                                    fontSize={0.75}
                                    fontWeight="normal"
                                    lineHeight="medium"
                                >
                                    dal lunedì al venerdì: 09:00 / 13:00 - 14:00 / 18:00
                                </Text>
                            </Hidden>
                            <Hidden above="mobileXl">
                                <Text
                                    paddingLeft={{ mobile: 'stdplus', tablet: 'large' }}
                                    fontSize={0.75}
                                    fontWeight="normal"
                                    lineHeight="medium"
                                >
                                    dal lunedì al venerdì:
                                </Text>
                                <Text
                                    paddingLeft={{ mobile: 'stdplus', tablet: 'large' }}
                                    fontSize={0.75}
                                    fontWeight="normal"
                                    lineHeight="medium"
                                >
                                    09:00 / 13:00 - 14:00 / 18:00
                                </Text>
                            </Hidden>
                            <Text
                                paddingLeft={{ mobile: 'stdplus', tablet: 'large' }}
                                fontSize={0.75}
                                fontWeight="normal"
                                lineHeight="medium"
                            >
                                (festivi e 7 dicembre esclusi)
                            </Text> */}
                    </FlexView.Item>
                </FlexView.Container>
            </HeroContent>
        </HeroContainer>
        <Container marginY="xl" paddingX={{ mobile: 'm', desktop: 'none' }} paddingY={{ mobile: 'l', tablet: 'xl' }}>
            <FlexView.Container
                flexDirection={{ mobile: 'column', tablet: 'row' }}
                marginBottom="3xl"
                paddingBottom="m"
                justifyContent="spaceAround"
            >
                <FlexView.Item
                    width={{ mobile: 'full', tablet: '1/2' }}
                    marginBottom={{ mobile: '3xl', tablet: 'none' }}
                    className={styles.btnOptions}
                    textAlign="center"
                >
                    <TextPreset preset="paragraph-xl">Non sei ancora un Cliente Saturno Assicurazioni?</TextPreset>
                    <AppLink
                        className={styles.heroButtonSinistri}
                        href="mailto:info@saturno.it"
                        marginTop={{ mobile: 's', tablet: 'm' }}
                    >
                        <TextPreset
                            preset="label-xl"
                            display="block"
                            width="full"
                            lineHeight="xl"
                            fontWeight="medium"
                            className={styles.heroButtonSinistriLabel}
                        >
                            info@saturno.it
                        </TextPreset>
                    </AppLink>
                </FlexView.Item>
                <FlexView.Item
                    width={{ mobile: 'full', tablet: '1/2' }}
                    className={styles.btnOptions}
                    textAlign="center"
                >
                    <TextPreset preset="paragraph-xl">Sei già un Cliente Saturno Assicurazioni?</TextPreset>
                    <AppLink
                        className={styles.heroButtonSinistri}
                        href="mailto:polizze@saturno.it"
                        marginTop={{ mobile: 's', tablet: 'm' }}
                    >
                        <TextPreset
                            preset="label-xl"
                            display="block"
                            width="full"
                            lineHeight="xl"
                            fontWeight="medium"
                            className={styles.heroButtonSinistriLabel}
                        >
                            polizze@saturno.it
                        </TextPreset>
                    </AppLink>
                </FlexView.Item>
            </FlexView.Container>
            <Documents />
            <TextPreset
                preset="paragraph-m"
                lineHeight="xl"
                fontWeight="medium"
                paddingTop={{ mobile: '3xl', desktop: 'l' }}
            >
                * Il prodotto Saturno è acquisibile solamente per il tramite dell&apos;intermediario Facile.it Broker di
                Assicurazioni S.p.A. con socio unico, e il relativo servizio clienti contattabile al numero su indicato
                è gestito dallo stesso intermediario principale.
            </TextPreset>
        </Container>
    </>
)

export default Contatti
